module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("INTENSE PAIN")]), _vm._v(" woke Farrell from a deep sleep. He opened his eyes and drew a ragged breath. The throbbing assault on his mind ended an instant later, leaving only a dull echo. A scan of his burns showed no distress or pain. Still, the sensations had been too vivid to be a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He lay back and stared at the ceiling as his head sank into the soft pillow. The need to rest had nearly pulled him back to sleep when his head erupted in pain. The powerful scream lacked the mind-searing agony Nerti’s exuded when Nordric had died, but it still made him wince. When he closed his eyes, he saw nothing but bright white light. Unlike the grief that fueled Nerti’s outburst, this radiated terror.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("A sheen of cold sweat formed on his forehead as he tried to assess the threat. How had someone slipped past his shields? Even Nerti and Rothdin couldn’t get in and out that easily. Only Miceral had this much access to him and the scream wasn’t from him.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He held his breath, ready to pounce. When the mental shriek came, he grabbed it. It hadn’t gotten into his mind; it was calling to him with such force it hurt. The unknown caller was scared beyond words, almost like a child….")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Geena!”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell jumped off the bed and ran to the nursery. When she’d been scared at Trellham, he’d dispelled her fear. She must have instinctively reached for him again, only this time it was more intense.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He burst into the suite without thinking and startled Urana, who sat knitting in the common room. Her scream should have woken the children, but Farrell doubted it would. Geena’s spillage was so strong he wasn’t sure he could wake her at the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Urana dropped her knitting and clutched at her chest with both hands. “Your Majesty, what’s happening?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Sorry, but Geena is… is having a bad dream.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“She’s what?” The way she steadied herself surprised Farrell.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I can feel her… her emotions. I think she’s having a nightmare.” A bad one.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He slowly opened the door. Geena moved around as if someone were poking her. She had a look of pain that mirrored her shouts. He tried to probe her mind, but the jumble of thoughts kept him from reading much. If he pushed harder, he might see more, but he didn’t want to risk damage to her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Nerti?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“You should be sleeping, not calling me.” ")]), _vm._v("Her reproachful tone didn’t help his mood.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I would be, except something is wrong with Geena.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Then you should call the healer, not me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Nerti, please. You know me well enough that I’d do that if that were needed. It’s her mind. Fear is emanating from her and the projections are painful. It must be terrible considering how much it hurts me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“What’s causing it?”")]), _vm._v(" She reached out a link and Farrell grabbed it.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I don’t know. She’s fighting something, and I’m afraid if I try to push through I’ll hurt her.”")]), _vm._v(" Another stab of pain struck his unprotected mind. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Nerti, help me!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Open your eyes and let me see her.”")]), _vm._v(" Despite her calm tone, he sensed her unease.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell did as instructed and had to force himself to breathe. The silence lingered longer than he expected, but he knew better than to disturb her.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“The source of her discomfort is coming from Bren,”")]), _vm._v(" Nerti said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Her words struck him like a war hammer to the face. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Bren? How’s… it can’t be.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I don’t know, but Klissmor has a link with the child and is checking to see what bothers him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“His dream is of death and fear.”")]), _vm._v(" Klissmor’s voice was full of anger. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“It is not a natural dream. Someone is feeding his mind images of his parents’ death.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Who?”")]), _vm._v(" Farrell imagined the ways he would make that person suffer for hurting his son. When he found them, they’d—")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Be calm, Little One,”")]), _vm._v(" Nerti said in a soothing voice. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“We will find the source and end the threat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Geena’s screams left a dull ache in his mind, and he couldn’t stop his heart from pounding. Nerti and Klissmor alone would be a match for anyone; together, he didn’t know what could stop them.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He walked over to his son’s bed to calm himself. Bren clutched the sheets with his tiny hands, and his anger burned hotter.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Who’s doing this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He reached for Bren. At the least he could wake his son and end his terror.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Stop!”")]), _vm._v(" Nerti said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell froze with his hand nearly on Bren’s cheek. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“But I can end his nightmare.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“And we’ll lose our link to whoever is doing it.”")]), _vm._v(" The urgency in her tone made him retract his hand. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“This way we can end it for good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“The link is buried deep, but I see it,”")]), _vm._v(" Klissmor said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell didn’t like what he’d heard."), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v(" “Miceral!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Farrell! What’s wrong?”")]), _vm._v(" Fear oozed from Miceral’s question.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Get Kel and my mother.”")]), _vm._v(" Farrell tried to contain his fear. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Someone is feeding Bren nightmares.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“What!” ")]), _vm._v("Farrell heard his fear reflected back in Miceral’s voice. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“How…? Who…?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Klissmor and Nerti are trying to find out now.”")]), _vm._v(" He took a deep breath and held it. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Can you find Kel and my mother?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes. Of course. I’ll—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I’ve already summoned them,” ")]), _vm._v("Nerti said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“They’ll be there soon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I’ll wait for them and let them in,”")]), _vm._v(" Miceral said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Father and I are in the study.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell watched his daughter’s little face contort as if she were living what Bren saw in his mind. Twice her mouth opened as if she would scream, but only a small moan came out. He couldn’t stand to see Geena suffer, but he didn’t break the link. Nerti and Klissmor needed the connection to stay open to find the source.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Urana?” He waited until she looked at him. “Can you find Master Heather and tell her I need her best healer trained in empathy immediately?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("She stared at him for a moment and then glanced at Geena. “At once, Your Majesty.” She turned on her heel and walked away.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He wanted an update, but asking would get him a rebuke. Geena’s fear had taken a darker tone and her face contorted into a scowl. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Nerti, something’s changed. She’s gone from afraid to angry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“She’s fighting back in her dream,”")]), _vm._v(" Nerti said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“The soldiers are coming for Bren and her. She’s trying to defend them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“How can I help her… them?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Remaining calm is the best thing right now.”")]), _vm._v(" She sent a soothing touch through their link. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“We’re trying to trace the connection back without announcing ourselves. Whoever is doing this will sever the link if they detect us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Be….”")]), _vm._v(" He nearly told her to be careful. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Let me know how I can help.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“You can bring us to their room in a moment. We’re moving toward the Door outside our quarters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Before he answered, the front-door spell alerted him to someone’s arrival. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Let me know when you’re ready.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“We’re waiting for Rothdin. He is better at this than we are.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell raised an eyebrow at the admission. His adopted father had a formidable mind, but for Nerti to admit he surpassed her spoke to how serious she considered the matter.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Miceral and Horgon appeared in the doorway with Zenora, Kel, and Heminaltose behind them. Judging by their expressions, Nerti must have briefed them.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Have you shielded her from Bren’s thoughts?” Zenora asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I would have, but Nerti said not to.” He held up his hand to stop her and Miceral’s objections. “They need the link open to find the source. If we alert whoever is doing this we know what’s happening, we may lose the chance to stop them.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I agree,” Kel said. “If we catch them unaware now, we can sever their link for good. If they know we’re watching, they’ll take precautions to try to hide their presence next time.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Damn it to the Eight Gates of Neblor,” Miceral said. When everyone turned to him, he threw his hands out. “Why attack a child? What do they hope to gain?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“There are many things I could think to do if it were me.” Kel shook his head. “Let’s focus on ending the threat before we speculate on what they hope to accomplish.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell put his hand on Miceral’s back and rubbed it. “Easy. Nerti and Klissmor won’t let any harm come to Bren.” He said it as much to reassure himself as his partner.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Rothdin is here. We are ready,”")]), _vm._v(" Nerti said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Are you by the Door?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Step back,” he told them as he found a spot to open the Door. “Nerti and Klissmor are coming with Rothdin.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“And Hesnera,”")]), _vm._v(" Nerti added.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He scanned the room and hoped everyone would fit.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Everyone but Miceral and Farrell should step out,” Kel said. “Even you, Zenora. I’m as close to them as anyone, and I include myself in this. The room is too small for everyone, and their parents should be here.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Grateful for Kel’s help, Farrell remembered to make the Door big enough for a peregrine. When he’d locked in the points, he needed a moment to clear his thoughts so he could picture the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Nerti led the way after the Door flared to life. She and Hesnera went to Geena’s bed while Rothdin and Klissmor attended Bren.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Hesnera and I will guard the girl while Rothdin finds the one behind this,”")]), _vm._v(" Nerti said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Klissmor has a link with Bren, so they are better suited for that task.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He watched anxiously as the two bent over Geena. Hesnera spread her wings as if to block something and Nerti touched her horn to Geena’s cheek. His daughter shuddered and gulped a lungful of air. Instantly, her face relaxed. She rolled onto her stomach and grabbed her pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Nerti and I diverted the hurtful thoughts into my mind to ease her suffering,”")]), _vm._v(" Hesnera said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“It won’t alert anyone to our presence.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell heard her but had already turned his attention to Bren. Klissmor was attempting to get between the bed and the wall. Without asking why, Farrell extended his arm and slowly moved the wooden frame.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He couldn’t see Bren, so Farrell moved to the foot of the bed with Miceral at his side. Without thinking, he reached for Miceral’s hand and entwined their fingers. His father lowered his beak until it was inches from the sleeping child, and Klissmor did the same with his horn. They stayed there for several seconds until suddenly they dipped their heads at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Bren convulsed and Farrell stifled a scream. Miceral did the same and squeezed his hand. When Rothdin and Klissmor moved away, Bren smiled happily and rolled onto his side.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“What happened?”")]), _vm._v(" he asked, hoping he wasn’t disturbing them.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“It is done,”")]), _vm._v(" Rothdin said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“The presence is gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I left him dreaming of riding on my back,”")]), _vm._v(" Klissmor said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Your son has the heart of a Muchari warrior.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“But what happened?” Miceral asked. “Who was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“A priestess of Neldin had a connection to my grandson.”")]), _vm._v(" Rothdin sounded angry. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I followed the link back to the source and terminated it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Priestess of Neldin?” Zenora asked. “How is that possible?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“The night of the coronation in Trellham.” Farrell glanced at Miceral. “Geena said Bren had a bad dream. She woke us and half the palace guard.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“That is a great deal different than a priestess with a way into your son’s mind,” Zenora said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell nodded. “I agree. When it happened I thought it something from when Trellham was overrun. No one had lived in the palace since the start of the war. I assumed it was just an echo from those dark days.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“The palace was the first place Neldin’s creatures attacked,” Kel said. “A spawn of Neblor could have survived this much time, but not a priestess.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“The priestess used the creature of Neldin’s to find an unprotected mind,”")]), _vm._v(" Rothdin said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“She found my grandson and soon realized his significance. She was trying to get to Geena as she is old enough to be useful. The perceived attack she was fighting when we arrived was the priestess trying to get to her. It is good we caught it now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Is she gone for good?” Miceral’s voice betrayed his angst.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“She will not bother either of them again,”")]), _vm._v(" Klissmor said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“How can you be so sure?” Horgon asked. “No disrespect, but they found a way inside his mind once. What’s to prevent them from doing it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Rothdin’s feathers puffed in a way Farrell couldn’t read. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“The witch of Neldin is dead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“She’s….” Farrell looked from Rothdin to Klissmor and then to Nerti and Hesnera. From their expressions, something had happened they didn’t want to talk about. “How… how do you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Once I found the source, Rothdin and I raced across the link and attacked the mind of the tormentor.” ")]), _vm._v("Klissmor avoided looking at Farrell.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Did you…?” Zenora asked. “Is she…?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“She’s dead, Mother,” Farrell said. “The witch deserved nothing less.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I’m confused. How could they kill her from here?” Miceral asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“They overpowered the priestess’s mind,” Farrell said. “While she was using it to feed Bren nightmares, the link left her mind defenseless.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Entering the mind of another is not something we do lightly,”")]), _vm._v(" Klissmor said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Anyone who would torment a hatchling deserves nothing less.”")]), _vm._v(" Rothdin sounded defiant. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“She paid the price for harming my family.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“How did you…?” The rush of excitement that they made her suffer turned Farrell’s stomach. He closed his eyes and shook his head. “I don’t want to know.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I do!” Miceral said. “I want to know how you can be sure the children are safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“As your mate said, we shattered her mind.”")]), _vm._v(" Rothdin spoke without the usual exuberance a peregrine displayed after a fight. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“We reflected the fear she inflicted on Bren, only many times stronger.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“You scared her to death,” Kel said with a grin. “That’s a fitting end to a servant of Neldin’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I take no pride in my actions.”")]), _vm._v(" Rothdin’s feathers moved to show his anger. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Such an act is an abomination. Only because the priestess was an extreme danger to Bren did I do that which Honorus has forbidden.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“We did this together, old friend. If Honorus judges you harshly, Lenore will do the same to me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Wait.” Farrell held up his hand. “The Six forbade you to do this and you did it anyway? Won’t Honorus and Lenore be angry?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I’m certain They are already angry with us,”")]), _vm._v(" Rothdin said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“The witch, however, tortured two younglings. Such cowardice does not deserve the protection afforded others.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“You are floating on thin air,” Kel said. “I’m not sure a forbidden act is forgiven if the reason behind it is honorable.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“"), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Should the Holy Father seek to punish me for my deed, He will let me know.” ")]), _vm._v("Rothdin still sounded angry. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“There is nothing more to say.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Urana returned with Master Heather and another healer in tow before Kel could reply. Zenora and Miceral explained the situation to her, and Farrell used the opportunity to approach his father.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He spread his arms wide, and Rothdin surrounded Farrell with his wings.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“That… what you did, Father. I’m grateful beyond words, but you should not have put your lives at risk like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I tire of Neldin and His servants ignoring the rules they expect us to follow.”")]), _vm._v(" His voice lacked any hint of remorse. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I’ll accept any consequences for my actions today. So will Klissmor. We cannot win this war if we do not meet force with a like action.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I….” ")]), _vm._v("Farrell feared if he gave in to his base desire to hurt those who attacked his family and friends, he’d give Neldin a path into his soul. But his father’s words resonated with his core belief. They couldn’t win the war if they didn’t fight back with every weapon they had. If two opponents were equally matched, the one willing to cross a line usually won. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I agree, but that’s a dark road to go down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I understand your fear, Farrell, but this is not the same.”")]), _vm._v(" Rothdin pulled his wings tighter. Another presence came closer, and Farrell realized Hesnera had joined them. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Had I taken control of her mind and used her to harm defenseless members of her family, then I would be no better than she. I turned her weapon back on her and no one else.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“What you say is true, but the distinction you make is thin.”")]), _vm._v(" Farrell waited for a rebuke, but it never came. Instead Rothdin shifted enough to allow Hesnera to join them.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“You are correct to fear flying into a place with no room to turn around,”")]), _vm._v(" she said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“But you must not be afraid to set foot on the road. Every being comes to a moment like this in their lives. Often there are many. Each one will change you. But if you fear to raise your talon in defense of one who cannot fight back, you allow evil to win.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Even if saving them means losing myself?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“It is not the act of saving another that will cause you to turn your back on who you are,”")]), _vm._v(" Rothdin said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“It is the methods you use. Did you hold your enemy down and cut him slowly until he died? Or did you use a sharp talon to pierce his heart cleanly? Both use the same weapon, and reach the same result, but the journey is different.")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I know your fears, youngling, and you are right to be vigilant. But caution does not mean inaction. If it did, you’d give Neldin what He wants, but by a different route. The result, however, would be just as terrible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Had that been Neldin’s intent? If Farrell wouldn’t join Him, He’d sow the seeds of doubt to prevent action? It would be in keeping with what he knew of Neldin. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I will remember that, Father. I won’t give Him what He wants by any method.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Bren twisted in his bed and opened his eyes. “K’ssmor.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He stood up and pointed toward the subject of his dream. Klissmor moved closer and lowered his head slowly until his nose touched Bren’s cheek. The toddler giggled and grabbed the unicorn’s head with both hands. Klissmor stood patiently as Bren kissed him on the nose.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“It would appear your son has suffered no lasting effects,”")]), _vm._v(" Rothdin said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Relieved, Farrell laughed as did others around him. He’d have gone to collect his son, but he heard Geena rustle behind him. She sat up in bed, looking around.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Are you okay, sweetie?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Bren had a bad dream and he gave it to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Is it gone now?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Mhmm. Nerti and Hesnerka made it go away.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Hesnera, sweetie, not Hesnerka.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Leave the little one alone,”")]), _vm._v(" Hesnera said, pushing Farrell over so she could stand by the bed. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“She came close enough.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Heather appeared at his side. “I want Master Jina to examine the girl. I’ll go see to the boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell looked at Miceral, who rolled his eyes so far back he could practically see what was behind him. Farrell struggled to keep from laughing. “Their names are Bren and Geena, not Boy and Girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Boy, Girl, Bren, Geena. What does it matter? You knew I meant your daughter when I said, ‘the girl.’ Why waste time trying to remember the correct name.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I’m glad to note you don’t reserve your friendly side for everyone else but me.” Farrell stepped back so Master Jina could see Geena. Heather never answered as she went to examine Bren.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Geena clutched the rag doll she brought with her from Kel’s house. Looking at the old, worn doll, Farrell realized his “children” were older than every human in the room save Kel. He smiled at the thought of being a father to two thirteen-hundred-year-old children.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“What’s so funny?” Miceral came behind him and put his hand on Farrell’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Keeping his attention on Geena, he said, “Do you realize our children are older than we are?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“They’re older than… by the Six!”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell turned toward his partner and kissed his cheek. “It just occurred to me when I was looking at her doll.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Miceral slid his hand off Farrell shoulder and grabbed his hand instead. They watched Jina check for any lasting effects. He thanked the Six he’d put Geena in training before he left. Her familiarity with Master Jina kept the stress of the moment to a minimum. Finally the healer touched Geena’s nose with a finger, and the two smiled at each other.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Jina scooped Geena off the bed and pushed her toward Zenora and Kel. They each took a hand and walked her toward the playroom.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“She’s fine.” Jina turned around, and Farrell let out the breath he’d been holding. “It is well you are so attentive to her powers. She is strong, but I’m not sure she could have held out forever. Had the witch gotten a link to Geena, she could have used your daughter to tinker with everyone’s emotions.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“There are no lasting effects?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“None.” Jina sounded surprised. “To her it was just a dream.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Nerti and I made certain that is how she remembered it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Jina’s eyes opened wider. “You altered her memories?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Of course not.”")]), _vm._v(" Hesnera’s feathers moved, signaling her annoyance. Nerti didn’t look pleased either. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Nor did we try to manipulate her emotions. We told her it was a dream and she believed us.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Oh.” She nodded. “That would explain it. I had expected her to have some recognition of what happened. Her ability to comprehend things on an instinctual level is amazing.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“Speaking of that,” Farrell said. “How did she project her emotions into me?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“She did what?” Master Heather appeared next to him. She exchanged a look with her colleague. “Are you certain?”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“I have the pain echo to prove it. It was so painful it woke me from a healing sleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“She shouldn’t be able to do that,” Jina said. “Your shield ought to protect you from an empath’s talent. Especially that of a barely trained five-year-old.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“We will spend more time with the…. Geena.” Heather gave him a look daring him to say something. “That she can get into "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("your ")]), _vm._v("mind concerns me.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“She didn’t get into my mind, but she was able to make me feel her pain.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“Though she did not get into your thoughts, had you tried to ease her mind, you would have opened yourself to your daughter,”")]), _vm._v(" Nerti said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“And to the priestess.” Of all the issues he expected as a parent, having to be afraid to comfort his daughter wasn’t one of them. “I’ll be certain to be wary if something like this happens again. But we need to find out how she got to Bren.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“I agree,”")]), _vm._v(" Nerti said. "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("“If everything is back to normal, I would like to return to my quarters.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("There was a hidden message in her words, but Farrell didn’t understand. He tried to make eye contact, but she avoided looking at him. “I left the Door open.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“There is no lasting harm to either child,” Heather said. “I’ll check them both again tomorrow to be sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("As Heather spoke, the peregrines and unicorns moved as one toward the open portal. They disappeared without a word.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("“That was strange,” Miceral said.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Farrell nodded. “It was. It probably has to do with killing the priestess.”")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("He didn’t believe that, but it seemed to satisfy the others. Whatever the reason, he knew they’d tell him soon.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-990dd33a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0007.vue
// module id = 75
// module chunks = 0